<template>
    <div class="story-maker-sticker-menu-select">
        <div class="list hide-scrollbar">
            <div class="list-action">
                <div class="action mention" @click="$emit('addSticker', 'mention')">
                    <div class="icon"></div>
                    <p>{{ $t('dash.post-creator.story.sticker.mention') }}</p>
                </div>

                <div class="action music" :class="{disabled: !musicEnabled}" @click="() => musicEnabled && $emit('changeMenu', 'musicMenu')">
                    <div class="icon"></div>
                    <p>{{ $t('dash.post-creator.story.sticker.music') }}</p>
                </div>

                <div class="action link" @click="$emit('changeMenu', 'linkMenu')">
                    <div class="icon"></div>
                    <p>{{ $t('dash.post-creator.story.sticker.link') }}</p>
                </div>

                <div class="action text" @click="$emit('addSticker', 'text')">
                    <div class="icon"></div>
                    <p>{{ $t('dash.post-creator.story.sticker.text') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        stickers: Array,
        pageSelected: Object,
        pagesSelectedIncludeConciergerie: Boolean,
        backgroundIsVideo: Boolean,
    },

    computed: {
        musicEnabled() {
            return this.pagesSelectedIncludeConciergerie && !this.backgroundIsVideo
        },
    },
}
</script>
